import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';
import { isDesktop } from '@/Utils/UseMedia';
import { watch } from 'vue';

export const useSidebarStore = defineStore('sidebar', () => {
    const visible = useLocalStorage(
        'sidebar.visible',
        document.body.clientWidth > 992,
    );
    const unfoldable = useLocalStorage('sidebar.unfoldable', false);

    const toggleVisible = (value) => {
        visible.value = value !== undefined ? value : !visible.value;
    };

    const toggleUnfoldable = () => {
        unfoldable.value = !unfoldable.value;
    };

    const close = () => {
        visible.value = false;
    };

    if (document.body.clientWidth <= 992) {
        close();
    }

    // Ensure sidebar is always visible on desktop
    watch(
        isDesktop,
        (value) => {
            if (!!value) {
                visible.value = true;
            }
        },
        { immediate: true },
    );

    return { visible, unfoldable, toggleVisible, toggleUnfoldable, close };
});
